<script setup lang="ts">
import {
    IconAirport,
    IconBookOpen,
    IconCampside,
    IconCar,
    IconChurch,
    IconFilm,
    IconGasStation,
    IconHighway,
    IconHospital,
    IconLibrary,
    IconLodging,
    IconMapPin,
    IconPark,
    IconParking,
    IconPerson,
    IconPublicRoad,
    IconPuzzle,
    IconRestaurant,
    IconShop,
    IconTouristAttraction,
    IconTrainStation
} from '#components'

const props = defineProps({
    category: {
        type: String,
        default: 'unknown'
    }
})

const categoryToComponent: Record<string, Component> = {
    airport: IconAirport,
    association: IconPuzzle,
    campsite: IconCampside,
    'car-dealership': IconCar,
    church: IconChurch,
    cinema: IconFilm,
    company: IconTouristAttraction,
    highway: IconHighway,
    hospital: IconHospital,
    hotel: IconLodging,
    museum: IconTouristAttraction,
    park: IconPark,
    parking: IconParking,
    person: IconPerson,
    point: IconMapPin,
    'public-roads': IconPublicRoad,
    restaurant: IconRestaurant,
    school: IconBookOpen,
    'service-station': IconGasStation,
    shop: IconShop,
    station: IconTrainStation,
    'town-hall': IconLibrary,
    unknown: IconMapPin
}

const icon = computed<Component>(
    () => categoryToComponent[props.category] ?? IconMapPin
)
</script>

<template>
    <component :is="icon" class="size-6" />
</template>
